
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.927 7.367 9.766 18.527a.251.251 0 0 1-.356 0l-6.337-6.336a.251.251 0 0 1 0-.356l1.54-1.54a.252.252 0 0 1 .356 0l4.62 4.62 9.442-9.443a.252.252 0 0 1 .356 0l1.54 1.54a.251.251 0 0 1 0 .355Z"}})])
          )
        }
      }
    